import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d4931fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "attachment-dropdown-list m-0 py-1 px-0" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  class: "attachment-dropdown-list__item mb-1",
  disabled: ""
}, "Trello", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  class: "attachment-dropdown-list__item mb-1",
  disabled: ""
}, "Google Drive", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  class: "attachment-dropdown-list__item mb-1",
  disabled: ""
}, "Dropbox", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  class: "attachment-dropdown-list__item mb-1",
  disabled: ""
}, "OneDrive", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider mx-2" }, null, -1))
const _hoisted_7 = { class: "attachment-dropdown-list__attach px-2 mb-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 mb-1 fw-bold" }, "Attach a link", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  disabled: "",
  placeholder: "Paste any link here...",
  class: "form-control form-control-sm d-block mb-2"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Attach")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_action_button = _resolveComponent("action-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", {
        class: "attachment-dropdown-list__item mb-1",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleComputerUpload && _ctx.handleComputerUpload(...args)))
      }, "Computer"),
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5
    ]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _hoisted_9,
      _createVNode(_component_action_button, { disabled: "" }, {
        default: _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      })
    ]),
    _createElementVNode("input", {
      type: "file",
      ref: "fileInputComputer",
      class: "invisible",
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleFileInputChange && _ctx.handleFileInputChange(...args)))
    }, null, 544)
  ]))
}